import React from "react";
import { Box, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { getStepActions } from "./chartMindSteps";

/**
 * Under-tabs Back / Next / Skip for ChartMind note types.
 *
 * Parent (StepperPageHeader stepsInPage track) is the same width as the step
 * strip — Back/Next span that graphic, not the full page. Next fills with
 * primary as soon as the step gate is open; outlined while blocked.
 */
const ChartMindStepNav = ({
  currentStep,
  transcript,
  eventsCount = 0,
  selectedDiagnosesCount,
  selectedConfirmedDiagnosesCount,
  onContinueToDiagnosis,
  onContinueToExam = undefined,
  onContinueToPearls = undefined,
  onContinueToPlan,
  onContinueToConfirm,
  onContinueToTreatment,
  onContinueToEvents = undefined,
  onContinueToDischarge,
  onGenerateChart,
  onSkipToChart = undefined,
  onBack,
  cm0427Mode = false,
  inpatient = false,
  eventsNote = false,
  pearlsAvailable = true,
  nextLoading = false,
}) => {
  const config = getStepActions({
    currentStep,
    transcript,
    eventsCount,
    selectedDiagnosesCount,
    selectedConfirmedDiagnosesCount,
    cm0427Mode,
    inpatient,
    eventsNote,
    pearlsAvailable,
    handlers: {
      onContinueToDiagnosis,
      onContinueToExam,
      onContinueToPearls,
      onContinueToPlan,
      onContinueToConfirm,
      onContinueToTreatment,
      onContinueToEvents,
      onContinueToDischarge,
      onGenerateChart,
      onSkipToChart,
    },
  });

  if (!config.showBack && !config.showNext && !config.secondaryLabel) {
    return null;
  }

  const nextReady = Boolean(config.showNext && config.nextLabel && !config.nextDisabled);

  return (
    <Box
      data-testid="chartmind-step-nav"
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        py: 1,
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Box sx={{ flexShrink: 0, minWidth: 64 }}>
        {config.showBack ? (
          <Button size="large" variant="outlined" color="primary" onClick={onBack}>
            Back
          </Button>
        ) : null}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1,
          minWidth: 0,
        }}
      >
        {config.secondaryLabel && config.onSecondary ? (
          <LoadingButton
            size="large"
            variant="outlined"
            color="primary"
            onClick={config.onSecondary}
            disabled={config.secondaryDisabled || nextLoading}
            sx={{ whiteSpace: "nowrap" }}
            data-testid="chartmind-step-nav-secondary"
          >
            {config.secondaryLabel}
          </LoadingButton>
        ) : null}
        {config.showNext && config.nextLabel ? (
          <LoadingButton
            size="large"
            variant={nextReady || nextLoading ? "contained" : "outlined"}
            color="primary"
            loading={nextLoading}
            onClick={config.onNext}
            disabled={config.nextDisabled}
            sx={{ whiteSpace: "nowrap" }}
            data-testid="chartmind-step-nav-next"
            data-ready={nextReady ? "true" : "false"}
          >
            {config.nextLabel}
          </LoadingButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default ChartMindStepNav;
